module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-248.c960f35c.jpg";